import { Link } from "@chakra-ui/react"
import { FC, useState } from "react"
import { PiVirtualReality } from "react-icons/pi"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"

export const VRIcon: FC<{}> = () => {
  const roomStyles = useRecoilValue(brandingSelector)
//   const [isVR, setVR] = useState(false);

  // Currently no toggling happens, we only 'enter-vr'. The reason for this is that once we're in aframe vr we can't actually click this button again because we don't see it, hence exiting VR will be handled in a different way.
  const handleVRToggle = () => {
    const iframe = document.getElementById("trl-iframe") as HTMLIFrameElement
    // if (isVR) {
        // iframe.contentWindow.postMessage({command: "exit-vr"}, "*")
    // } else {
        iframe.contentWindow.postMessage({command: "enter-vr"}, "*")
    // }

    // setVR(!isVR);
  }

  return (
    <Link
      onClick={handleVRToggle}
      onTouchStart={handleVRToggle}
      zIndex="1000"
      margin="0 auto"
      id="FS"
      color={roomStyles?.overlayEmojiStrokeColor ?? "white"}
    >
      <PiVirtualReality size="2.8rem" className="fs-icon" />
    </Link>
  )
}
